import { Link } from '@chakra-ui/react';

export function termSheetDriveExportSuccessToast({
  fileName,
  fileUrl,
  googleDocName,
  googleDocUrl,
  folderUrl,
}) {
  return {
    title: `Saved to Drive — ${fileName}`,
    description: (
      <>
        <Link
          href={fileUrl}
          isExternal
          color="white"
          fontWeight="semibold"
          textDecoration="underline"
          _hover={{ color: 'whiteAlpha.900' }}
          mr={3}
        >
          Open Word file
        </Link>
        {googleDocUrl ? (
          <Link
            href={googleDocUrl}
            isExternal
            color="white"
            fontWeight="semibold"
            textDecoration="underline"
            _hover={{ color: 'whiteAlpha.900' }}
            mr={3}
          >
            Open Google Doc{googleDocName ? ` (${googleDocName})` : ''}
          </Link>
        ) : null}
        {folderUrl ? (
          <Link
            href={folderUrl}
            isExternal
            color="white"
            fontWeight="semibold"
            textDecoration="underline"
            _hover={{ color: 'whiteAlpha.900' }}
          >
            Open LOI folder
          </Link>
        ) : null}
      </>
    ),
    status: 'success',
    duration: 5000,
    isClosable: true,
  };
}
